// Fenster, das sich ueber die Seite legt (Overlay).
//
// Kuemmert sich um alles, was ein solches Fenster koennen muss:
//  - Escape schliesst
//  - Klick auf den dunklen Hintergrund schliesst
//  - Klick INNERHALB des Fensters schliesst NICHT
//  - die Seite dahinter scrollt nicht mehr mit
//  - der Tastatur-Fokus springt beim Oeffnen hinein und danach zurueck
import React, { useEffect, useRef } from "react";
import { useI18n } from "../I18nProvider";

export default function Overlay({ offen, titel, onSchliessen, children }) {
  const { t } = useI18n();
  const kastenRef = useRef(null);
  const vorherFokus = useRef(null);

  useEffect(() => {
    if (!offen) return;

    vorherFokus.current = document.activeElement;

    const beiTaste = (e) => {
      if (e.key === "Escape") onSchliessen();
    };
    document.addEventListener("keydown", beiTaste);

    // Seite dahinter festhalten. Die Breite der Bildlaufleiste ausgleichen,
    // sonst springt der Inhalt beim Oeffnen kurz zur Seite.
    const breite = window.innerWidth - document.documentElement.clientWidth;
    const vorherOverflow = document.body.style.overflow;
    const vorherPadding = document.body.style.paddingRight;
    document.body.style.overflow = "hidden";
    if (breite > 0) document.body.style.paddingRight = breite + "px";

    kastenRef.current?.focus();

    return () => {
      document.removeEventListener("keydown", beiTaste);
      document.body.style.overflow = vorherOverflow;
      document.body.style.paddingRight = vorherPadding;
      vorherFokus.current?.focus?.();
    };
  }, [offen, onSchliessen]);

  if (!offen) return null;

  return (
    <div className="overlay-grund" onClick={onSchliessen}>
      <div
        className="overlay-kasten"
        role="dialog"
        aria-modal="true"
        aria-label={titel}
        tabIndex={-1}
        ref={kastenRef}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="overlay-kopf">
          <h3>{titel}</h3>
          <button
            type="button"
            className="overlay-zu"
            onClick={onSchliessen}
            aria-label={t("hero.schliessen")}
          >
            <i className="fas fa-xmark" aria-hidden="true"></i>
          </button>
        </div>
        <div className="overlay-inhalt">{children}</div>
      </div>
    </div>
  );
}
